import React, {lazy, Suspense} from 'react'

const GamesPageLazy = lazy(() => import('./GamesPage'))

const GamesPage = props => (
  <Suspense fallback={null}>
    <GamesPageLazy {...props}/>
  </Suspense>
)

export default GamesPage
